import Pristine from "./pristine"

const app = {
  onResize: () => {
  },

  onScroll: () => {

  },

  alerts: () => {
    document.querySelectorAll(".alert").forEach(alert => {
      alert.show = () => alert.classList.add("is-active")
      alert.hide = () => alert.classList.remove("is-active")

      const closeButton = alert.querySelector(".alert__close")

      if (closeButton) {
        closeButton.addEventListener("click", alert.hide)
      }
    })

  },

  form: () => {
    const config = {
      classTo: "field",
      errorClass: "field--error",
      successClass: "field--success",
      errorTextParent: "field",
      errorTextTag: "span",
      errorTextClass: "field__error"
    }

    let form = document.querySelector("form")

    if (!form) return

    let successMsg = form.querySelector(".alert.alert--success")
    let errorMsg = form.querySelector(".alert.alert--error")
    const submit = form.querySelector("button[type=\"submit\"]")

    form.addEventListener("submit", event => {
      event.preventDefault();

      [successMsg, errorMsg].filter(msg => msg).forEach(msg => msg.hide())

      const validator = new Pristine(form, config, true)
      let formData = new FormData(form)

      if (validator.validate()) {
        submit.disabled = true

        fetch(wp.ajax, {
          method: "POST", body: formData
        })
          .catch(() => {
            errorMsg && errorMsg.show()
          })
          .then(request => request.json())
          .then(response => {
            if (response.success) {
              form.reset()
              successMsg && successMsg.show()
            }
          })
          .finally(() => {
            submit.disabled = false
          })
      }
    })
  },

  init: () => {
    app.alerts()
    app.form()
  },

  update: () => {
  }
}

document.addEventListener("DOMContentLoaded", () => {
  app.init()

  window.addEventListener("resize", app.onResize)
  window.addEventListener("scroll", app.onScroll)
  window.dispatchEvent(new Event("resize"))
  window.dispatchEvent(new Event("scroll"))
})
